<app-playground
    [backgrounds]="backgrounds$ | async"
    title="{{ 'MyMachine' | translate }}"
>
</app-playground>
@if (machine) {
    <div class="container" style="margin-bottom: -10px">
        <app-breadcrumbs class="col-lg d-md-inline d-none"></app-breadcrumbs>
        <div
            class="machineRow no-hover head-row d-flex"
            style="justify-content: space-between"
        >
            <div class="machine-infos">
                <img
                    src="//www.poettinger.at/img/icons_svg/300/{{
                        machine?.phkey
                    }}.svg"
                    alt="{{ machine?.phkey }}"
                    style="width: 10%; min-width: 66px; flex: 0"
                />
                <div>
                    @if (!isLoading) {
                        <div
                            class="head-row-detail editable"
                            style="max-width: 100%"
                        >
                            <div style="display: flex">
                                <div class="input-wrapper" style="flex: 1">
                                    <span class="size-span">{{
                                        machine.userDefinedName
                                    }}</span>
                                    <input
                                        [(ngModel)]="machine.userDefinedName"
                                        type="text"
                                        id="input-machine-custom-name"
                                        name="input-machine-custom-name"
                                        placeholder="Eigener Name"
                                    />
                                </div>
                                <label for="input-machine-custom-name">
                                    <i
                                        class="far fa-edit"
                                        style="
                                            font-size: 1.2em;
                                            margin-left: 0.5em;
                                            margin-right: 0.5em;
                                        "
                                    ></i>
                                </label>
                                @if (
                                    machine.userDefinedName !==
                                    lastSavedCustomName
                                ) {
                                    <button
                                        type="button"
                                        class="btn btn-primary btn-sm"
                                        (click)="onSaveMachineName(machine)"
                                    >
                                        Save
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    <div class="head-row-detail">{{ machine.name }}</div>
                    <div class="head-row-detail" id="sernr-hover-trigger">
                        {{ machine.machineNumber }}
                    </div>
                    <ion-popover
                        id="sernr-popover"
                        trigger="sernr-hover-trigger"
                        triggerAction="hover"
                        (mousemove)="onMouseMove($event)"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">{{ machine.sernr }}</ion-content>
                        </ng-template>
                    </ion-popover>
                </div>
            </div>
            <div class="head-row-detail">
                @if (isDetailsFetchRunning) {
                    <ion-spinner></ion-spinner>
                }
                @if (
                    machine?.suggestedTelemetryUnitId ||
                    machine?.connectedTelemetryUnitId
                ) {
                    <ion-chip
                        [color]="
                            machine?.connectedTelemetryUnitId
                                ? 'success'
                                : 'warning'
                        "
                    >
                        <ion-avatar>
                            <svg
                                id="a"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 226.77 226.77"
                            >
                                <defs>
                                    <style>
                                        .b {
                                            fill: none;
                                            stroke: currentColor;
                                            stroke-miterlimit: 10;
                                            stroke-linecap: round;
                                            stroke-width: 4px;
                                        }
                                    </style>
                                </defs>
                                <path
                                    class="b"
                                    d="M125.65,61.28c0,6.76-5.48,12.23-12.23,12.23-1.44,0-2.82-.25-4.1-.7-4.74-1.68-8.14-6.21-8.14-11.53,0-6.76,5.48-12.23,12.23-12.23s12.23,5.48,12.23,12.23Z"
                                />
                                <line
                                    class="b"
                                    x1="117.28"
                                    y1="73.33"
                                    x2="157.6"
                                    y2="210.35"
                                />
                                <line
                                    class="b"
                                    x1="109.69"
                                    y1="73.68"
                                    x2="69.47"
                                    y2="210.35"
                                />
                                <line
                                    class="b"
                                    x1="74.1"
                                    y1="195.55"
                                    x2="139.47"
                                    y2="152.84"
                                />
                                <line
                                    class="b"
                                    x1="152.38"
                                    y1="195.55"
                                    x2="87.01"
                                    y2="152.84"
                                />
                                <line
                                    class="b"
                                    x1="87.42"
                                    y1="150.84"
                                    x2="130.54"
                                    y2="122.66"
                                />
                                <line
                                    class="b"
                                    x1="139.06"
                                    y1="150.84"
                                    x2="95.94"
                                    y2="122.66"
                                />
                                <line
                                    class="b"
                                    x1="97.1"
                                    y1="120.05"
                                    x2="124.06"
                                    y2="102.44"
                                />
                                <line
                                    class="b"
                                    x1="129.38"
                                    y1="120.05"
                                    x2="102.42"
                                    y2="102.44"
                                />
                                <path
                                    class="b"
                                    d="M70.55,107.54c-11.94-11.02-19.53-27.52-19.53-45.98,0-17.99,7.21-34.13,18.64-45.14"
                                />
                                <path
                                    class="b"
                                    d="M81.5,97.04c-9.64-8.22-15.84-21.05-15.84-35.48,0-13.77,5.65-26.08,14.54-34.32"
                                />
                                <path
                                    class="b"
                                    d="M92.46,85.77c-7.2-5.16-11.95-14.07-11.95-24.2,0-9.54,4.21-18,10.71-23.26"
                                />
                                <path
                                    class="b"
                                    d="M156.22,107.54c11.94-11.02,19.53-27.52,19.53-45.98,0-17.99-7.21-34.13-18.64-45.14"
                                />
                                <path
                                    class="b"
                                    d="M145.28,97.04c9.64-8.22,15.84-21.05,15.84-35.48,0-13.77-5.65-26.08-14.54-34.32"
                                />
                                <path
                                    class="b"
                                    d="M134.31,85.77c7.2-5.16,11.95-14.07,11.95-24.2,0-9.54-4.21-18-10.71-23.26"
                                />
                            </svg>
                        </ion-avatar>
                        <ion-label>{{
                            machine.connectedTelemetryUnitId
                                ? "Telemetrieeinheit verbunden"
                                : "Telemetrieeinheit gefunden"
                        }}</ion-label>
                        @if (machine?.connectedTelemetryUnitId) {
                            <ion-icon
                                name="ellipsis-vertical"
                                id="telemetry-popover-trigger"
                            ></ion-icon>
                        } @else {
                            <ion-button
                                size="small"
                                class="chip-button"
                                color="warning"
                                (click)="linkTelemetryUnit()"
                                (keydown.enter)="linkTelemetryUnit()"
                                >verbinden</ion-button
                            >
                        }
                    </ion-chip>
                    <ion-popover
                        trigger="telemetry-popover-trigger"
                        dismissOnSelect="true"
                        #telemetryPopover
                    >
                        <ng-template>
                            <ion-content>
                                <ion-list>
                                    <ion-item
                                        [button]="true"
                                        [detail]="false"
                                        (click)="
                                            openChangeTelemetryUnitPinModal()
                                        "
                                        (keydown.enter)="
                                            openChangeTelemetryUnitPinModal()
                                        "
                                    >
                                        <ion-label>PIN Code ändern</ion-label>
                                    </ion-item>
                                </ion-list>
                            </ion-content>
                        </ng-template>
                    </ion-popover>
                }
                <div
                    class="editable align-center d-flex"
                    style="flex: 0"
                    (click)="onDeleteUserMachine(machine)"
                    (keydown.enter)="onDeleteUserMachine(machine)"
                >
                    <ion-icon name="trash-outline" class="delete-icon" aria-hidden="true"></ion-icon>
                </div>
            </div>
        </div>
        @if (isLoading) {
            <app-progress-spinner></app-progress-spinner>
        }
    </div>
}

<app-machinepage [embedded]="embedded"></app-machinepage>
